import React, { useEffect, useState, useRef } from "react";
import { useCookies } from "react-cookie";
import JSshare from "./JSshare";
import styles from "../RequestForQuotePage/index.module.css";
import WishlistImages from "./WishlistImages";
// import { LoadingOverlay, Loader } from "react-overlay-loader";
import "../../black-box/custom.css";
import { IoArrowBack, IoCloseOutline, IoAlertCircle } from "react-icons/io5";
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import "../../black-box/custom.css";
import { TextField } from "@material-ui/core";




const GetWishlist = () => {
    const [setting, setSetting] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [commentPopup, setcommentPopup] = useState(false);
    const [comment, setcomment] = useState('');
    const [commentAttr, setcommentAttr] = useState([]);

    const [removeCompare, setremoveCompare] = useState('');
    const [selectedCheckbox, setselectedCheckbox] = useState({});
    const [getWishlistproduct, setWishlistProduct] = useState([]);
    const [getWishlistProductALL, setWishlistProductAll] = useState([]);
    const [getWishlist, setWishlist] = useState([]);
    const [cookies, setCookie, removeCookie] = useCookies("gemfind_sessionId");
    const [loaded, setLoaded] = useState(false);
    const [loadApi, setloadApi] = useState(true);
    const [callremove, setCallRemove] = useState(false);
    const [checked, setchecked] = useState(false);
    const [getImage, setImage] = useState([]);
    const [currentTab, setCurrentTab] = useState('');
    const [sortOrder, setsortOrder] = useState('asc');
    const [sortCategory, setsortCategory] = useState('all');
    const [Categories, setCategories] = useState('');


    const handleAppSetting = async () => {
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "appSetting",
            requestOptions
        );
        const app_setting = await res.json();
        setSetting(app_setting.data);
    };

    useEffect(() => {
        handleAppSetting();
    }, []);

    const getQuotedProductCount = async () => {
        setLoaded(true);
        const requestOptions = {
            method: "POST",
            // mode: "no-cors",
            // headers: {
            //     'Content-Type': 'application/json'
            // },

            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                product_id: "",
                saveforlater: "false",
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "myWishlist",
            requestOptions
        );
        const set_count = await res.json();
        var wishlist_status_pro = set_count.data.wishlist_status;
        var wishlists = set_count.data.wishlists;
        var images = {};
        Object.keys(wishlists).map(key => {
            var arr = [];
            var i = 0;
            wishlist_status_pro.map(item => {
                if (item.wishlist_id == wishlists[key]) {
                    arr[i] = item.image;
                    i++;
                }
            })
            images[key] = arr;
        })
        var data = set_count.data.wishlist_status;
        // const categories = [...new Set(data.map(item => item.productCategory))];
        const categories = [...new Set(data.map(item => item.productCategory).filter(productCategory => productCategory))];
        setCategories(categories);

        data.sort(function (a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });
        setImage(images);
        setWishlist(set_count.data.wishlists);
        setWishlistProduct(data);
        setWishlistProductAll(data);
        setLoaded(false);
        setloadApi(false);
    };
    useEffect(() => {
        if (loadApi === true) {
            getQuotedProductCount();
        }
    }, [loadApi, getWishlist, getWishlistproduct]);



    const handleRemoveClick = async () => {
       // setCallRemove(true);
       setLoaded(true);
        let formData = {
            'items': []
        };
        //console.log(selectedProducts)
         Object.keys(selectedCheckbox).map(key => {
            
            var arr = {};
            selectedProducts.map(item =>{
                if(item.var_id === key){
                    //arr['handle'] = item.handle;
                    formData.items.push(item.handle);
                }
                
            })
            /* console.log(arr);
            console.log(arr.length)
            if(arr.length>0){
                formData.items.push(arr);
            } */




            /* selectedProducts.map(item =>{
                if(item.var_id === key){
                    //arr['handle'] = item.handle;
                    formData.items.handle.push(item.handle);
                }
               
                
            }) */
            
           
        });
        console.log(formData)
        const promises = formData.items.map(item => {
            const requestOptions = {
                method: "POST",
                body: JSON.stringify({
                    shop_domain: window.Shopify.shop,
                    session_id: cookies.gemfind_sessionId,                   
                    saveforlater: "false",
                    handle:item,
                    product_id: "",
                    customer_id:
                        window.meta.page.customerId != undefined
                            ? window.meta.page.customerId
                            : null
                })
            };
            console.log(requestOptions)
            return fetch(`${process.env.REACT_APP_API_URL}` + "removeWishlist",requestOptions)
              .then(response=> {
              return response.json()
            });
          });
        
          Promise.all(promises).then(results => {
            console.log("done with promise")
            setselectedCheckbox([])
            //const res = results.map(result => result);
           // console.log(res);
            getQuotedProductCount();
          })
         /*  Promise.all(promises).then(results => {
            console.log("done with promise")
            //const res = results.map(result => result);
           // console.log(res);
            getQuotedProductCount();
          }) */
       
    };

    const handleTabClick = (e) => {
        e.stopPropagation();
        setCurrentTab(e.target.id);
    }
    const backClick = () => {
        setCurrentTab('');
    }

    // useEffect(() => {
    //     const sortedProducts = [...getWishlistproduct];
    //     if (sortOrder === 'asc') {
    //         sortedProducts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    //     } else {
    //         sortedProducts.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
    //     }
    //     setWishlistProduct(sortedProducts);
    // }, [sortOrder])

    useEffect(() => {
        const sortedProducts = [...getWishlistProductALL];
        if (sortOrder === 'asc') {
            sortedProducts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
        } else {
            sortedProducts.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
        }
        if (sortCategory == 'all') {
            setWishlistProduct(sortedProducts);
        } else {
            const filteredArray = sortedProducts.filter(item => item.productCategory === sortCategory);
            setWishlistProduct(filteredArray);
        }
    }, [sortCategory, sortOrder])

    function sortOrderFunc(e) {
        setsortOrder(e.target.value);
    }
    function sortCategoryfunc(e) {
        setsortCategory(e.target.value);
    }


    useEffect(() => {
        const selected = selectedCheckbox;
        // console.log(selectedCheckbox)
        setselectedCheckbox(selected);
    }, [selectedCheckbox, checked])


    function multipleInputSelection(e) {
        setchecked(!checked);
console.log()
        if (selectedCheckbox[e.target.value]) {
            delete selectedCheckbox[e.target.value];
        } else {
            selectedCheckbox[e.target.value] = e.target.getAttribute('data-quan');
        }
    }
    function multipleaddtocart() {
        let formData = {
            'items': []
        };

        Object.keys(selectedCheckbox).map(key => {
            var arr = {};
            arr['id'] = key;
            arr['quantity'] = selectedCheckbox[key];
            formData.items.push(arr);
        });

        // console.log(formData)
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                window.location.href = '/cart';
            })
            .catch((error) => {
                console.error('Error:', error);
            });


    }

    function compareProducts() {

        if (Object.keys(selectedCheckbox).length > 3) {
            alert("You can compare max 3 products.");
        } else if (Object.keys(selectedCheckbox).length <= 1) {
            alert("You can compare min 2 products.");
        } else {
            setIsOpen(true);
        }

    }
    function removeProductsCompare(id) {
        const updatedSelectedCheckbox = { ...selectedCheckbox };
        delete updatedSelectedCheckbox[id];
        setselectedCheckbox(updatedSelectedCheckbox);
        setTimeout(() => {
            if (Object.keys(selectedCheckbox).length <= 1) {
                setIsOpen(false);
            }
        }, 500);
    }
    useEffect(() => {
        removeProductsCompare(removeCompare);
        setremoveCompare('');
    }, [removeCompare])

    const rowRefs = useRef([]);

    const selectedProducts = Object.keys(selectedCheckbox).map(key =>
        getWishlistproduct.find(item => item.var_id == key)
    ).filter(item => item !== undefined);


    function OpencommentPopupFunc(var_id) {
        var data = getWishlistproduct.find(item => item.var_id == var_id);
        setcomment(data.comments);
        setcommentAttr({ 'var_id': data.id, 'wishlist_id': data.wishlist_id })
        setcommentPopup(true);

    }

    const commentsUpdate = async () => {
        setLoaded(true);
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                var_id: commentAttr.var_id,
                session_id: cookies.gemfind_sessionId,
                wishlist_id: commentAttr.wishlist_id,
                comments: comment,
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "updateComments",
            requestOptions
        );
        const app_setting = await res.json();
        setSetting(app_setting.data);
        setloadApi(true);
        setcommentPopup(false);
        setLoaded(false);
    };

    const setEqualHeight = () => {
        const elements = document.querySelectorAll('.same-height');
        let maxHeight = 0;

        elements.forEach((el) => {
            el.style.height = 'auto'; // Reset height
            const height = el.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        elements.forEach((el) => {
            el.style.height = `${maxHeight}px`;
        });
    };
    useEffect(() => {
        setEqualHeight();
    }, [currentTab])

    window.addEventListener('resize', setEqualHeight);
    // console.log(getWishlistproduct)

    const findTotalVariants = (var_id) => {
        console.log(var_id)
        console.log("getwhishlist");
        console.log(getWishlistproduct);
        const product = getWishlistproduct.find(item => item.var_id === var_id);
        return product ? product.totalVariants : 0;
    };
    console.log("selectedcheckbox")
    console.log(selectedCheckbox)
    const shouldHideButton = Object.keys(selectedCheckbox).some(id => findTotalVariants(id) >= 2);
    console.log("should"+shouldHideButton);
    useEffect(()=>{
        if(loaded){
            document.querySelector(".gf--loader--body").style="display:block;";
        }else{
            document.querySelector(".gf--loader--body").style="display:none;";
        }
    },[loaded]);
    console.log("===="+setting.plan > 2 );
    console.log("shoud"+!shouldHideButton)

    const hidebtn = currentTab != '' ? 'gf--steps-container-hide' : '';

    const content1 = (
        <>
            {getWishlist != '' ? (
                <>
                    {/* <LoadingOverlay className="_loading_overlay_wrapper">
                        <Loader fullPage loading={loaded} />
                    </LoadingOverlay> */}
                    <Modal
                        open={commentPopup}
                        onClose={() => setcommentPopup(false)}
                        center
                        classNames={{
                            overlay: "popup_Overlay",
                            modal: "popup-form-extra-small comments--modal"
                        }}>
                        {/* <LoadingOverlay className="_loading_overlay_wrapper">
                            <Loader fullPage loading={loaded} />
                        </LoadingOverlay> */}
                        <div>
                            <h3 className="gf-wishlist-head">Your Comment</h3>
                        </div>
                        <div className="comment-form">
                            <div className="form-field">
                                <TextField
                                    type="text"
                                    label="Comment"
                                    multiline
                                    rows={4}
                                    variant="filled"
                                    value={comment}
                                    onChange={(e) => { setcomment(e.target.value) }}
                                />
                            </div>
                            <button className="gf--btn" onClick={() => { commentsUpdate() }}>
                                Update comment
                            </button>
                        </div>
                    </Modal>

                    <Modal
                        open={isOpen}
                        onClose={() => setIsOpen(false)}
                        center
                        classNames={{
                            overlay: "popup_Overlay",
                            modal: "popup-form-extra-small compareProduct--modal"
                        }}
                    >
                        <div className={styles.gemgridrow}>
                            <div className="gf-compare-pro-header">
                                <h3>Compare Products</h3>
                            </div>
                            <div className={styles.gridcontainer + " gf--com-pro-container"} style={{ marginTop: 0 }}>
                                <table className="gf-compare-table" border="1px" style={{ marginTop: "20px" }}>
                                    <thead>
                                        <tr>

                                            {selectedProducts.map((item, index) => (
                                                <th key={item.var_id}>
                                                    <div className="gf-compare-product-header">

                                                        <div className="gf--compare-product-img">
                                                            <button onClick={() => setremoveCompare(item.var_id)} className="gf-compare-product-remove">
                                                                <IoCloseOutline />
                                                            </button>
                                                            <img src={item.image} alt={item.title} className={styles.productImage} />
                                                        </div>

                                                        <h4>{item.title}</h4>
                                                        <p>${item.price}</p>
                                                    </div>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr><td colspan="5">Available</td></tr>
                                        <tr>

                                            {selectedProducts.map((item, index) => (
                                                <td key={item.var_id}>
                                                    {item.quantity > 0 ? "Yes" : 'No'}
                                                </td>
                                            ))}
                                        </tr>
                                        <tr><td colspan="5">Product Type</td></tr>
                                        <tr>

                                            {selectedProducts.map((item, index) => (
                                                <td key={item.var_id}>
                                                    {item.productType || '-'}
                                                </td>
                                            ))}
                                        </tr>
                                        <tr><td colspan="5">SKU</td></tr>
                                        <tr>

                                            {selectedProducts.map((item, index) => (
                                                <td key={item.var_id}>
                                                    {item.sku || '-'}
                                                </td>
                                            ))}
                                        </tr>

                                        <tr><td colspan="5">Available Options</td></tr>
                                        <tr>

                                            {selectedProducts.map((item, index) => (
                                                <td key={item.var_id}>
                                                    {item.totalVariants || '-'}
                                                </td>
                                            ))}
                                        </tr>
                                        <tr><td colspan="5">Category</td></tr>
                                        <tr>

                                            {selectedProducts.map((item, index) => (
                                                <td key={item.var_id}>
                                                    {item.productCategory || '-'}
                                                </td>
                                            ))}
                                        </tr>
                                        <tr><td colspan="5">Vendor</td></tr>
                                        <tr>

                                            {selectedProducts.map((item, index) => (
                                                <td key={item.var_id}>
                                                    {item.vendor || '-'}
                                                </td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>


                            </div>
                        </div>
                    </Modal>
                    <div className={styles.gemgridrow}>
                        <div className={"gf--tab--header"}>

                            <h2 className={currentTab == '' ? '' : 'gf--steps-back-btn-hide'}>My Wishlist</h2>
                            {setting.plan > 1 ?
                                <div className={currentTab != '' ? '' : 'gf--steps-back-btn-hide'}><JSshare currentTab={currentTab} /></div>
                                : ""}

                            {setting.plan > 1 ?
                                <div className="gf--products-sort-div">
                                    <h2>{currentTab}</h2>
                                    <div className={"gf-back--btn gf-product-filters " + `${currentTab != '' ? '' : 'gf--steps-back-btn-hide'}`}>
                                        <div>
                                            <label >Price: </label>
                                            <select onChange={(e) => sortOrderFunc(e)} >
                                                <option value="asc">Low to High</option>
                                                <option value="desc">High to Low</option>
                                            </select>
                                        </div>
                                        {Categories.length > 0 ?
                                            <div>
                                                <label >Categories: </label>
                                                <select onChange={(e) => sortCategoryfunc(e)} >
                                                    <option value="all">All Products</option>
                                                    {Categories.map(item => (
                                                        <option value={item}>{item}</option>
                                                    )
                                                    )}
                                                </select>
                                            </div>
                                            : ''}
                                    </div>
                                </div>
                                : ''}


                        </div>

                        <div className={"gf--header-addbtn " + `${currentTab != '' ? '' : 'gf--steps-back-btn-hide'}`}>
                            <button onClick={() => { backClick(); setselectedCheckbox([]); }} className={"gf-back--btn " + `${currentTab != '' ? '' : 'gf--steps-back-btn-hide'}`} >
                                <IoArrowBack />
                                <p>Back</p>
                            </button>
                            <div className="gf--add-compare-btns">
                                <button onClick={handleRemoveClick} className={"gf--add-to-cart-btn deleteAll"}>Delete All</button>
                               
                                {setting.plan > 2 && !shouldHideButton ?
                                    <button onClick={multipleaddtocart} className={"gf--add-to-cart-btn " + `${Object.keys(selectedCheckbox).length == 0 ? 'gf--steps-back-btn-hide' : ''}`} >Add to cart<span>{Object.keys(selectedCheckbox).length}</span></button>
                                    : ""}

                                {setting.compare_products_option !== "false" ?
                                    <button onClick={compareProducts} className={"gf--add-to-cart-btn compareBtn" + `${Object.keys(selectedCheckbox).length == 0 ? 'gf--steps-back-btn-hide' : ''}`} >Compare Products<span>{Object.keys(selectedCheckbox).length}</span></button>
                                    : ""}

                            </div>
                        </div>
                        <div className={styles.gridcontainer}>
                            {Object.keys(getWishlist).map(key =>
                                key != 'U0ZM' ?
                                    <>
                                        <div className={styles.gridbox + " gf--steps-btn " + hidebtn} id={key} disabled={currentTab === `${key}`} onClick={(handleTabClick)}>
                                            <div className={styles.productimg} id={key}>
                                                <WishlistImages imageUrls={getImage[key]} id={key} />
                                            </div>
                                            <div className={styles.productinfo} id={key}>
                                                <h2 id={key}>
                                                    {key}
                                                </h2>
                                            </div>
                                        </div>
                                        <div className={"gf--steps-content"}>
                                            {currentTab === `${key}` &&
                                                <>
                                                    {getWishlistproduct.map(item => (
                                                        getWishlist[key] == item.wishlist_id ?
                                                            <div className={styles.gridboxChild}>
                                                                <div className="gf-wishlist-pro-quantity">{"Quantity: " + item.quantity}</div>

                                                                <input style={{display:"block", margin:"2px 2px 0 0"}}  onChange={(e) => multipleInputSelection(e)} data-quan={item.quantity} className="gf--input-selection" type="checkbox" value={item.var_id} checked={selectedCheckbox[item.var_id]} />
                                                                {/* disabled={item.totalVariants <= 1 ? '' : 'disabled'} */}
                                                                <div className={styles.productimg}>
                                                                    <img src={item.image} alt="watch" />
                                                                </div>
                                                                <div className={styles.productinfo}>
                                                                    <h2 className={'same-height ' + styles.Product_title}>
                                                                        {item.title}
                                                                    </h2>
                                                                    <h3 className={styles.Product_price}>
                                                                        ${item.price}
                                                                    </h3>
                                                                    {item.stock_status != "In Stock" ? (
                                                                        <span
                                                                            className={
                                                                                styles.Productstock +
                                                                                " " +
                                                                                styles.outofstock
                                                                            }
                                                                        >
                                                                            out of stock
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className={
                                                                                styles.Productstock +
                                                                                " " +
                                                                                styles.instock
                                                                            }
                                                                        >
                                                                            instock
                                                                        </span>
                                                                    )}
                                                                    <div className={styles.addtocartbtn + " gf-card-footer"}>
                                                                        <div>

                                                                            <a href={item.product_link}>
                                                                                View More
                                                                            </a>


                                                                        </div>
                                                                        {setting.wishlist_comments_option === "false" ? "" :
                                                                            <button className="tooltip gf--comment-btn" onClick={() => OpencommentPopupFunc(item.var_id)}>
                                                                                <IoAlertCircle />
                                                                                <span class="tooltiptext">
                                                                                    View your comment text.
                                                                                </span>
                                                                            </button>}
                                                                    </div>

                                                                    {/* <button onClick={()=>handleRemoveClick(item.id)} className="gf-remove-btn">Remove</button> */}
                                                                </div>
                                                            </div>
                                                            : ''))}

                                                </>
                                            }
                                        </div >
                                    </>
                                    : '')}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <style>
                        {`
                    .react-overlay-loader-spinner {
                        background-image: url(${process.env.REACT_APP_IMAGE_URL}"images/heart_loader.gif");
                    }
                `}
                    </style>
                    {/* <LoadingOverlay className="_loading_overlay_wrapper">
                        <Loader fullPage loading={loaded} />
                    </LoadingOverlay> */}

                    <div className={styles.gemgridrow}>
                        <div className="gf-no-sfl">
                            Love It? Add To My Wishlist
                            <p>My Wishlist allows you to keep track of all of your favorites and shopping activity whether you're on your computer, phone, or tablet. You won't have to waste time searching all over again for that item you loved on your phone the other day - it's all here in one place!</p>
                            <a href={'/'}>Continue shopping</a>
                        </div>
                    </div>
                </>
            )
            }
        </>
    );

    return (
        <>{content1}</>
    );

}

export default GetWishlist;